module.exports = __webpack_public_path__ + "img/pic_Ecua_Guayaquil.85ca86f5.jpg";